<template>
  <div class="property-input">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <input type="file" ref="inputFileFont" style="display: none" accept=".ttf,.otf" @change="onFileChanged" multiple/>
    <div class="input-block">
      <button class="play-button" v-if="property.name == 'PressAnimation'" @click="container.playPressAnimation = true">
        <playIcon :width="15" :height="15"/>
      </button>
      <button class="play-button" v-if="property.name == 'Animation'" @click="container.playAnimation = true">
        <playIcon :width="15" :height="15"/>
      </button>
      <button class="play-button" v-if="property.name == 'Police' || property.name == 'TextPolice'" @click="$refs.inputFileFont.click()">
        <addIcon :width="15" :height="15"/>
      </button>
      <multiselect
        ref="multiselect"
        :modelValue="selectedValues"
        :options="options"
        :multiple="property.multiple"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        :searchable="false"
        :select-label="''"
        :deselect-label="''"
        :selected-label="''"
        placeholder="Sélectionner"
        :customLabel="label"
        :track-by="trackingOption"
        :preselect-first="false"
        @update:modelValue="updateValues"
      >
        <template #option="{ option }" >
          <div class="option-container" :style="specialStyle(option)">
            {{ label(option) }}
            <Tooltip v-if="option && option.tooltip" :text="option.tooltip" />
            <div class="option-container-button" v-if="option.canBeDeleted">
              <button class="play-button" @click="askDeleteRessource($event, option)">
                <deleteIcon :width="15" :height="15"/>
              </button>
            </div>
          </div>
        </template>
      </multiselect>
    </div>
    <DeleteConfirmPopup
      :show="showDeleteConfirmPopup"
      :elementName="confirmDeleteElement?.name"
      @confirm="deleteRessource"
      @cancel="showDeleteConfirmPopup = false"
    />
  </div>
</template>

<script>
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import * as mutations from "../../vuexStore/mutations.js"
import { mapActions, mapMutations } from "vuex"
import playIcon from "../IconComponents/playIcon.vue"
import addIcon from "../IconComponents/addIcon.vue"
import Multiselect from 'vue-multiselect'
import Tooltip from "../Tooltip.vue"
import api from "../../api/user.js"
import DeleteConfirmPopup from "../PopupComponents/DeleteConfirmPopup.vue"
import deleteIcon from "../IconComponents/deleteIcon.vue"

export default {
  name: 'Select',
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: [Number, String, Array, null],
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    eventOnChangeRessource: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: [
  ],
  components: {
    playIcon,
    addIcon,
    Multiselect,
    Tooltip,
    DeleteConfirmPopup,
    deleteIcon
  },
  data() {
    return {
      showDeleteConfirmPopup: false,
      confirmDeleteElement: null
    }
  },
  computed: {
    selectedValues() {
      if (this.property.multiple) {
        return this.element.map(v => this.property.options.find(el => el.idSoft == v))
      }
      else {
        if (this.element) {
          return [this.property.options.find(el => el.idSoft == this.element)]
        }
        return [];
      }
    },
    trackingOption() {
      if (this.property.optionsType) {
        return this.property.optionsType;
      } else {
        return "text"
      }
    },
    options() {
      if (Array.isArray(this.property.options) == false) {
        return Object.entries(this.property.options);
      }
      else {
        return this.property.options;
      }
    }
  },
  methods: {
    ...mapMutations(namespaceStore.THEME, {
      'clearRessource': mutations.REMOVE_RESSOURCE
    }),
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY,
      'uploadRessource': actions.UPLOAD_RESSOURCE,
      'removeRessource': actions.REMOVE_RESSOURCE
    }),
    ...mapActions(namespaceStore.MESSAGE, [
      "addMessage"
    ]),
    askDeleteRessource(event, option) {
      event.stopPropagation();
      this.$refs.multiselect.deactivate()
      this.showDeleteConfirmPopup = true;
      this.confirmDeleteElement = option;
    },
    deleteRessource() {
      this.removeRessource({clear: false, idSoft: this.confirmDeleteElement.idSoft}).then(res => {
        if (this.selectedValues.find(el => el.idSoft == this.confirmDeleteElement.idSoft)) {
          this.$refs.multiselect.removeElement(this.confirmDeleteElement);
        }
        this.clearRessource(this.confirmDeleteElement.idSoft);
      }).finally(() => {
        this.showDeleteConfirmPopup = false;
        this.confirmDeleteElement = null;
      });
    },
    sendFileToServer(file) {
      const formData = new FormData();
      formData.append('fichier', file);
      formData.append('nom', file.name.replace(/\.[^/.]+$/, "").toUpperCase());
      formData.append('description', `Fichier uploadé: ${file.name}`);
      formData.append('type_ressource', "font");
      this.uploadRessource(formData).then(response => {
        this.$refs.multiselect.select(response.ressource);
      }).finally(() => {
        if (this.$refs.inputFileFont) {
          this.$refs.inputFileFont.value = '';
        }
      });
    },
    onFileChanged(event) {
      for (const file of event.target.files) {
        this.sendFileToServer(file);
      }
    },
    label(selectedValue) {
      if (selectedValue.text) {
        return selectedValue.text
      }
      return selectedValue.name
    },
    specialStyle(option) {
      if (this.property.style == "fontFamily") {
        return {
          fontFamily: option.name
        };
      }
      return {}
    },
    updateValues(value) {
      if (this.eventOnChangeRessource == true) {
        this.$emit('eventOnChangeRessource', value)
        return;
      }
      if (value == null && this.property.options.length > 0) {
        value = this.property.options.find(el => el.canBeDeleted == false);
        if (value == null) {
          return;
        }
      }
      else if (value == null) {
        return;
      }
      this.updateProperty({
        element: this.container,
        property: this.property,
        value: this.property.multiple == true ? value.map(v => v.idSoft) : value.idSoft
      });
    },
  },
  created() {
  }
}
</script>

<style scoped>
.option-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.property-label {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
}
.input-block {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0;
}

.play-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}

.play-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.play-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.property-select {
  padding: inherit;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: #e5e7eb;
  transition: all 0.2s ease;
  cursor: pointer;
  flex: 1;
  padding: 0.25rem;
}

.property-select:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: rgba(255, 255, 255, 0.15);
}

.property-select:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.property-select option {
  background-color: #1f2937;
  color: #e5e7eb;
}

/* Styles pour vue-multiselect */
:deep(.multiselect) {
  flex: 1;
}

:deep(.multiselect__tags) {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: #e5e7eb;
  padding: 0.25rem;
  display: flex;
  align-items: center;
}

:deep(.multiselect__tags-wrap) {
  display: flex;
  gap: 0.25rem;
}

:deep(.multiselect__select) {
  border-radius: 0 0.25rem 0.25rem 0;
  height: 100%;
  width: 20px;
  padding: 0px;
}

:deep(.multiselect__select:before) {
  border-color: #e5e7eb transparent transparent;
}

:deep(.multiselect__option) {
  background-color: #1f2937;
  color: #e5e7eb;
  padding: 0.5rem;
}

:deep(.multiselect__placeholder) {
  margin-bottom: 0;
}

:deep(.multiselect__option--highlight) {
  background-color: #343946;
  color: white;
}

:deep(.multiselect__option--selected) {
  /* background-color: #2563eb; */
  color: white;
}

:deep(.multiselect__single) {
  color: #e5e7eb;
  background-color: transparent;
  margin: 0;
}

:deep(.multiselect__tag) {
  background-color: #3b82f6;
  color: white;
  border-radius: 0.25rem;
  margin: 0;
}

:deep(.multiselect__tag-icon) {
  border-right: 0;
  color: white;
}

:deep(.multiselect__tag-icon:after) {
  color: white;
}

:deep(.multiselect__tag-icon:focus),
:deep(.multiselect__tag-icon:hover) {
  background-color: #2563eb;
}

:deep(.multiselect__content-wrapper) {
  background-color: #1f2937;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
}

:deep(.multiselect__input),
:deep(.multiselect__single) {
  background-color: transparent;
  color: #e5e7eb;
}

:deep(.multiselect__input::placeholder) {
  color: #9ca3af;
}
</style>